export const ServiceReminderBookNowButton = {
  displayMode: 'email',
  category: 'Buttons',
  tags: ['Request', 'Appointment', 'Service Reminder', 'CTA', 'Book Now'],
  data: {
    cells: [1],
    columns: [
      {
        contents: [
          {
            type: 'button',
            values: {
              containerPadding: '10px',
              anchor: '',
              href: {
                name: 'web',
                values: {
                  href: '{{tinyUrl}}',
                  target: '_blank',
                },
                attrs: {
                  href: '{{href}}',
                  target: '{{target}}',
                },
              },
              buttonColors: {
                color: '#FFFFFF',
                backgroundColor: '#3CA0B4',
                hoverColor: '#FFFFFF',
                hoverBackgroundColor: '#3CA0B4',
              },
              size: {
                autoWidth: true,
                width: '100%',
              },
              textAlign: 'center',
              lineHeight: '120%',
              padding: '10px 30px',
              border: {},
              borderRadius: '4px',
              hideDesktop: false,
              displayCondition: null,
              _meta: {
                htmlClassNames: 'u_content_button',
              },
              selectable: true,
              draggable: true,
              duplicatable: false,
              deletable: false,
              hideable: false,
              text: '<span style="font-size: 14px; line-height: 16.8px;">Book Now</span>',
              calculatedWidth: 124,
              calculatedHeight: 37,
            },
          },
        ],
        values: {
          backgroundColor: '',
          padding: '0px',
          border: {},
          borderRadius: '0px',
          _meta: {
            htmlClassNames: 'u_column',
          },
        },
      },
    ],
    values: {
      displayCondition: null,
      columns: false,
      backgroundColor: '',
      columnsBackgroundColor: '',
      backgroundImage: {
        url: '',
        fullWidth: true,
        repeat: 'no-repeat',
        size: 'custom',
        position: 'center',
      },
      padding: '0px',
      anchor: '',
      _meta: {
        htmlClassNames: 'u_row',
      },
      selectable: true,
      draggable: true,
      duplicatable: true,
      deletable: true,
      hideable: true,
    },
    schemaVersion: 11,
  },
  custom: true,
};
